<div class="w-full h-full flex items-center justify-center">
  <mat-icon [svgIcon]="solid() ? 'logo-solid-new' : 'logo-new'" />
</div>
